import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// employee used in a Transaction Tender's CreatorDetails
// TODO(ELDM-3473): Determine whether this model can be deleted.
export default ProtoBaseModel.extend({
  userToken: attr(String),
  name: attr(String),
  profilePhotoUrl: attr(String),
  mobileStaffId: attr(String),
  active: attr(Boolean)
});